import {
  Aggregator,
  CALCWEIGHT,
  PIECE,
  SKETCHTICKET,
  SKETCHTICKET_SIZE,
  TICKET,
  getProduct,
  getToDay,
} from '@/models/GenerateCondit/Interrelated';
import GenerateCondit, { Bound } from '@/models/GenerateCondit';
import { GetOrganizationAuth, getProvinceAreaData } from '@/services/area';
import { getData, getTimestampData, updateFile } from '@/components/report/service';

import BigNumber from 'bignumber.js';
import DeliveryRoute from '@/Entity/DeliveryRoute';
import Queryable from '@/Entity/Tools/Queryable';
import lodash from 'lodash';
import { message } from 'antd';
import moment from 'moment';

const dateRange = getToDay();
const formatNumber = (num) => {
  try {
    // 尝试将 num 转换为 BigNumber 实例，BigNumber 支持字符串和数字类型
    const bigNum = new BigNumber(num);

    if (!bigNum.isFinite() || bigNum.isNaN()) {
      console.log('Invalid input for formatNumber:', num);
      return 0; // 处理非数值输入，返回默认值
    }

    // 使用 BigNumber 保留两位小数，四舍五入
    const rounded = bigNum.decimalPlaces(2).toNumber();

    return rounded;
  } catch (error) {
    console.log('Error in formatNumber:', error);
    return 0; // 如果转换过程中出现异常，返回默认值
  }
};
const params = {
  queryDate: moment(dateRange[0]).add(-1, 'days'), // moment(new Date()).format('YYYY-MM-DD 12:00:00'),
  queryType: 0,
};

export default {
  namespace: 'notpressrouteboardNew',
  state: {
    // 汇总-占比
    dataList: [],
    dateRange,

    // 查询条件
    searchFrom: { ...params },
    // 折线图
    productList: [],
    // 柱状图 数据
    productPieList: [],
    productWeightList: [],

    // 营运区 数据
    provinceList: [],
    xAxisList: [],
    y1AxisList: [],
    y2AxisList: [],
    ticketCount: 0,
    allTicketCount: 0,

    xAxisListWeight: [], // 结算重量数据
    y1AxisListWeight: [],
    y2AxisListWeight: [],
    weightCount: 0,
    allWeightCount: 0,

    productMarkTicketList: [],
    productMarkWeightList: [],

    showTable: false,
    showProvinceTab: false,
  },

  effects: {
    *getData(_, { call, put, select }) {
      try {
        console.log('开始执行 getData effect');

        //#region 图
        yield put({ type: 'getCountry' });
        yield put({ type: 'getProduct' }); // 获取产品类型占比
        yield put({ type: 'getProductMark' }); // 获取环节数据

        //#endregion
        const {
          searchFrom: { queryDate, queryType },
        } = yield select(({ notpressrouteboardNew }) => notpressrouteboardNew);

        const productType = getProduct(queryType);

        const access = yield GetOrganizationAuth();
        yield getProvinceAreaData();
        const payload = {
          showTable: !access.isCenter, showProvinceTab: access.isHead || access.isArea
        }
        yield put({
          type: 'updateState',
          payload: payload,
        });
        if (access.isCenter) {
          return;
        }

        console.log('开始获取数据 getData',payload);
        const [
          dayDataList,
          totalDataList,
          centerDayDataList,
          centerTotalDataList,
          provincePieceList,
          centerPieceList,
        ] = yield Promise.all([
          fetchOneDayData(queryDate, ['loadProvinceArea'], productType, access),
          fetchOneDayTotal(queryDate, ['scanProvinceArea'], productType, access),
          fetchOneDayData(queryDate, ['loadCenter'], productType, access),
          fetchOneDayTotal(queryDate, ['scanSite'], productType, access),
          fetchOneDayPieceData(queryDate, ['loadProvinceArea'], productType, access),
          fetchOneDayPieceData(queryDate, ['loadCenter'], productType, access),
        ]);

        console.log('getData 数据获取完成,开始处理数据');
        const [
          dayData,
          totalData,
          centerDayData,
          centerTotalData,
          provincePieceData,
          centerPieceData,
        ] = [
          getDayData(dayDataList, 'loadProvinceArea'),
          getTotal(totalDataList, 'scanProvinceArea'),
          getDayData(centerDayDataList, 'loadCenter'),
          getTotal(centerTotalDataList, 'scanSite'),
          getPieceData(provincePieceList, 'loadProvinceArea'),
          getPieceData(centerPieceList, 'loadCenter'),
        ];

        let dataList = dayData.map(day => {
          const findTotal = totalData.find(total => day.loadProvinceArea === total.scanProvinceArea);
          const findPiece = provincePieceData.find(
            total => day.loadProvinceArea === total.loadProvinceArea,
          );
          return { ...findTotal, ...findPiece, ...day };
        });

        const centerDataList = centerDayData.map(day => {
          const findTotal = centerTotalData.find(total => day.loadCenter === total.scanSite);
          const findPiece = centerPieceData.find(total => day.loadCenter === total.loadCenter);
          return { ...findTotal, ...findPiece, ...day };
        });
        const _payload = { dataList, centerDataList };
        console.log('营运区,分拨',_payload);
        yield put({ type: 'updateState', payload: _payload });

      } catch (error) {
        console.error('getData effect error:', error);
        message.error('获取数据失败,请稍后重试');
      }

      function getDayData(dayDataList, fieldKey) {
        const data = new Queryable(dayDataList).GroupByField(fieldKey);
        const dataList = [];
        Object.keys(data).forEach(key => {
          const temp = { [fieldKey]: key, monthTicket: 0, monthCalcWeight: 0 };
          data[key].forEach(item => {
            // const i = parseInt(moment(item.time).format('DD'));
            // temp[`sketchTicket${i}`] = item.SketchTicket;
            // temp.monthTicket += item.SketchTicket;

            const piece = Math.abs(item.piece);
            temp[`sketchTicket`] = item.SketchTicket || item.sketchTicket;
            temp['calcWeight'] = item.calcWeight;

            // temp.monthTicket += item.SketchTicket;
            // temp.monthCalcWeight += item.calcWeight;
          });
          dataList.push(temp);
        });
        return dataList;
      }

      function getTotal(dayDataList, fieldKey) {
        const data = new Queryable(dayDataList).GroupByField(fieldKey);
        const dataList = [];
        Object.keys(data).forEach(key => {
          const temp = { [fieldKey]: key, monthTotalTicket: 0, monthTotalCalcWeight: 0 };
          data[key].forEach(item => {
            // const i = parseInt(moment(item.time).format('DD'));
            // const ticket = Math.abs(item.ticket);
            // temp[`ticket${i}`] = ticket;
            const ticket = Math.abs(item.ticket);
            const calcWeight = Math.abs(item.calcWeight);
            temp[`ticket`] = ticket;
            temp[`allCalcWeight`] = calcWeight;
          });
          dataList.push(temp);
        });
        return dataList;
      }

      function getPieceData(dayDataList, fieldKey) {
        const data = new Queryable(dayDataList).GroupByField(fieldKey);
        const dataList = [];
        Object.keys(data).forEach(key => {
          const temp = { [fieldKey]: key, monthTicket: 0, monthCalcWeight: 0 };
          data[key].forEach(item => {
            const piece = Math.abs(item.piece);
            temp['piece'] = item.piece;
          });
          dataList.push(temp);
        });
        return dataList;
      }
    },
    //全国--折线图
    *getCountry(_, { call, put, select }) {
      try {
        console.log('开始执行 getCountry effect');
        const access = yield GetOrganizationAuth();
        const {
          searchFrom: { queryDate, queryType },
        } = yield select(({ notpressrouteboardNew }) => notpressrouteboardNew);
        const productType = getProduct(queryType);

        console.log('开始获取折线图数据');
        const [dayDataList, totalDataList] = yield Promise.all([
          fetchDataLine(queryDate, productType, access),
          fetchTotalLine(queryDate, productType, access),
        ]);

        console.log('数据获取完成,开始处理数据');
        const xAxisList = [];
        const y1AxisList = [];
        const y2AxisList = [];
        let ticketCount = 0;
        let allTicketCount = 0;

        const xAxisListWeight = [];
        const y1AxisListWeight = [];
        const y2AxisListWeight = [];
        let weightCount = 0;
        let allWeightCount = 0;

        for (let index = 0; index < totalDataList.length; index++) {
          const totalItem = totalDataList[index];
          let dayItem = dayDataList.find(
            m => m.timestamp.slice(0, 10) === totalItem.timestamp.slice(0, 10),
          ) ?? { sketchTicket: 0, calcWeight: 0 };
          const formattedWeight = formatNumber(dayItem.calcWeight);

          const totalTicket = Math.abs(totalItem.ticket || 0);
          const totalWeight = Math.abs(totalItem.calcWeight || 0);

          xAxisList.push(moment(totalItem.timestamp).format('YYYY-MM-DD HH:mm:ss'));
          y1AxisList.push(formatNumber(dayItem.sketchTicket));
          y2AxisList.push(totalTicket === 0 ? 0 : formatNumber((dayItem.sketchTicket / totalTicket) * 100));
          ticketCount += formatNumber(dayItem.sketchTicket);
          allTicketCount += formatNumber(totalTicket);

          xAxisListWeight.push(moment(totalItem.timestamp).format('YYYY-MM-DD HH:mm:ss'));
          y1AxisListWeight.push(formatNumber(dayItem.calcWeight));
          y2AxisListWeight.push(totalWeight === 0 ? 0 : formatNumber((dayItem.calcWeight / totalWeight) * 100));
          if (!isNaN(formattedWeight)) {
            weightCount += formattedWeight;
          } else {
            console.log('Invalid weight:', dayItem.calcWeight);
          }
          allWeightCount += formatNumber(totalWeight);
        }
        const payload = {
          xAxisList,
          y1AxisList,
          y2AxisList,
          xAxisListWeight,
          y1AxisListWeight,
          y2AxisListWeight,
          ticketCount,
          allTicketCount,
          weightCount,
          allWeightCount,
        }
        console.log('数据处理完成,更新状态',payload);
        yield put({
          type: 'updateState',
          payload: payload,
        });
      } catch (error) {
        console.error('getCountry effect error:', error);
        message.error('获取全国数据失败,请稍后重试');
      }
    },
    //产品--饼状图
    *getProduct(_, { call, put, select }) {
      try {
        console.log('开始执行 getProduct effect');
        const access = yield GetOrganizationAuth();
        const {
          searchFrom: { queryDate, queryType },
        } = yield select(({ notpressrouteboardNew }) => notpressrouteboardNew);
        const productType = getProduct(queryType);

        console.log('getProduct 开始获取饼状图数据');
        const result = yield fetchDataPie(queryDate, productType, access);
        console.log('%c [ getProduct fetchDataPie ]-313', 'font-size:13px; background:pink; color:#bf2c9f;', result)

        console.log('getProduct 数据获取完成,开始处理数据');

        const allTicket = result.reduce((pre, curr) => pre + Number(curr.SketchTicket), 0);
        console.log('%c [ getProduct allTicket ]-318', 'font-size:13px; background:pink; color:#bf2c9f;', allTicket)
        const allWeight = result.reduce((pre, curr) => pre + Number(curr.calcWeight), 0);
        console.log('%c [ getProduct allWeight ]-320', 'font-size:13px; background:pink; color:#bf2c9f;', allWeight)

        const productPieList = result
          .sort((item1, item2) => Number(item2.SketchTicket) - Number(item1.SketchTicket))
          .map(item => {
          // const allTicket = result.reduce(pre, curr => pre + curr);
            return {
              name: item.productType,
              value: `${((Number(item.SketchTicket) / allTicket) * 100).toFixed(2)}`,
            };
          });

        const productWeightList = result
          .sort((item1, item2) => Number(item2.calcWeight) - Number(item1.calcWeight))
          .map(item => {
            return {
              name: item.productType,
              value: `${((Number(item.calcWeight) / allWeight) * 100).toFixed(2)}`,
            };
          });
        const payload = {
          productPieList,
          productWeightList
        }
        console.log('getProduct 产品类型占比票数-结算重量', payload);
        yield put({
          type: 'updateState',
          payload: payload,
        });
      } catch (error) {
        console.error('getProduct effect error:', error);
        message.error('getProduct 获取产品数据失败,请稍后重试');
      }
    },

    //产品--环节柱状图数据
    *getProductMark(_, { call, put, select }) {
      try {
        console.log('getProductMark 开始执行 getProductMark effect');
        const access = yield GetOrganizationAuth();
        const {
          searchFrom: { queryDate, queryType },
        } = yield select(({ notpressrouteboardNew }) => notpressrouteboardNew);
        const productType = getProduct(queryType);

        console.log('getProductMark 开始获取环节柱状图数据');
        const result = yield fetchDataMark(queryDate, productType, access);

        console.log('getProductMark 数据获取完成,开始处理数据');

        const allTicket = result.reduce((pre, curr) => pre + Number(curr.SketchTicket), 0);
        const allWeight = result.reduce((pre, curr) => pre + Number(curr.calcWeight), 0);

        const productMarkTicketList = result
          .sort((item1, item2) => Number(item2.SketchTicket) - Number(item1.SketchTicket))
          .map(item => {
          // const allTicket = result.reduce(pre, curr => pre + curr);
            return {
              name: item.locationMark,
              value: `${((Number(item.SketchTicket) / allTicket) * 100).toFixed(2)}`,
            };
          });

        const productMarkWeightList = result
          .sort((item1, item2) => Number(item2.calcWeight) - Number(item1.calcWeight))
          .map(item => {
            return {
              name: item.locationMark,
              value: `${((Number(item.calcWeight) / allWeight) * 100).toFixed(2)}`,
            };
          });
        const payload ={
          productMarkTicketList,
          productMarkWeightList
        }
        console.log('getProductMark 环节占比票数-结算重量',payload);
        yield put({
          type: 'updateState',
          payload: payload,
        });
      } catch (error) {
        console.error('getProductMark getProductMark effect error:', error);
        message.error('getProductMark 获取环节数据失败,请稍后重试');
      }
    },
    *updateFile({ payload }, { call, put, select }) {
      try {
        console.log('开始执行 updateFile effect');
        const formData = new FormData();
        formData.append('file', payload.sheet2blob, payload.fileName + ".xlsx");
        formData.append('pageName', payload.pageName);

        console.log('开始上传文件');
        const result = yield call(updateFile, formData);
        if (result && result.code === 1) {
          message.success('导出成功');
        } else {
          throw new Error('导出失败');
        }
      } catch (error) {
        console.error('updateFile effect error:', error);
        message.error('导出失败,请稍后重试');
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};

// 获取本月至今每天数据
function fetchData(dateRange, ...productType) {
  try {
    console.log('开始获取本月至今每天数据');
    const condit = new GenerateCondit({
      dataSource: 'delivery_dis_accord_result',
      dimensions: ['loadProvinceArea'],
      aggregators: [SKETCHTICKET, CALCWEIGHT],
      startDate: moment(moment(dateRange).format('YYYY-MM-01 12:00:00')).format(
        'YYYY-MM-DD 12:00:00',
      ),
      endDate: moment(dateRange)
        .add(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss'),
      simpleGranularity: null,
      durationGranularity: {
        duration: '86400000',
        origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
      },
    }).converCondit({ ...productType });
    const result = getData(condit,'druid2');
    console.log('获取本月至今每天数据成功');
    return result;
  } catch (error) {
    console.error('获取本月至今每天数据失败:', error);
    return [];
  }
}

// 获取一天数据
function fetchOneDayData(dateRange, dimensions, productType, access) {
  try {
    console.log('开始获取一天数据');
    const condit = new GenerateCondit({
      dataSource: 'delivery_dis_accord_result',
      dimensions: dimensions,
      aggregators: [SKETCHTICKET, CALCWEIGHT],
      startDate: moment(dateRange).format('YYYY-MM-DD 12:00:00'),
      endDate: moment(dateRange)
        .add(1, 'days')
        .format('YYYY-MM-DD 12:00:00'),
      simpleGranularity: 'all',
    }).converCondit({
      ...productType,
      [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
    });
    const result = getData(condit,'druid2');
    console.log('获取一天数据成功');
    return result;
  } catch (error) {
    console.error('获取一天数据失败:', error);
    return [];
  }
}

// 获取一天数据
function fetchOneDayPieceData(dateRange, dimensions, productType, access) {
  try {
    console.log('开始获取一天件数数据');
    const condit = new GenerateCondit({
      dataSource: 'delivery_dis_accord_result',
      dimensions: dimensions,
      aggregators: [new Aggregator('thetaSketch', 'piece', 'subBillNo', 32768)],
      startDate: moment(dateRange).format('YYYY-MM-DD 12:00:00'),
      endDate: moment(dateRange)
        .add(1, 'days')
        .format('YYYY-MM-DD 12:00:00'),
      simpleGranularity: 'all',
    }).converCondit({
      ...productType,
      [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
    });
    const result = getData(condit,'druid2');
    console.log('获取一天件数数据成功');
    return result;
  } catch (error) {
    console.error('获取一天件数数据失败:', error);
    return [];
  }
}

function fetchTotal(dateRange, ...productType) {
  try {
    console.log('开始获取总计数据');
    const condit = new GenerateCondit({
      dataSource: 'actual_load_unload_waybill_day_result',
      dimensions: ['scanProvinceArea'],
      aggregators: [TICKET, CALCWEIGHT],
      startDate: moment(moment(dateRange).format('YYYY-MM-01 00:00:00')).format(
        'YYYY-MM-DD 00:00:00',
      ),
      endDate: moment(dateRange)
        .add(1, 'days')
        .format('YYYY-MM-DD 00:00:00'),
      simpleGranularity: 'day',
    }).converCondit({ scanType: '分拨装车', ...productType });
    const result = getData(condit,'druid2');
    console.log('获取总计数据成功');
    return result;
  } catch (error) {
    console.error('获取总计数据失败:', error);
    return [];
  }
}

// 获取一天总计数据
function fetchOneDayTotal(dateRange, dimensions, productType, access) {
  try {
    console.log('开始获取一天总计数据');
    const condit = new GenerateCondit({
      dataSource: 'actual_load_unload_waybill_day_result',
      dimensions: dimensions,
      aggregators: [TICKET, CALCWEIGHT],
      startDate: moment(dateRange).format('YYYY-MM-DD 00:00:00'),
      endDate: moment(dateRange).format('YYYY-MM-DD 23:59:59'),
      simpleGranularity: 'day',
    }).converCondit({
      scanType: '分拨装车',
      ...productType,
      [access.isArea ? 'scanProvinceArea' : 'scanSite']: access?.name,
    });
    const result = getData(condit,'druid2');
    console.log('获取一天总计数据成功');
    return result;
  } catch (error) {
    console.error('获取一天总计数据失败:', error);
    return [];
  }
}

function fetchDataLine(dateRange, productType, access) {
  try {
    console.log('开始获取折线图数据');
    const condit = new GenerateCondit({
      dataSource: 'delivery_dis_accord_result',
      dimensions: null,
      aggregators: [SKETCHTICKET_SIZE(17), CALCWEIGHT],
      startDate: moment(moment(dateRange).format('YYYY-MM-01 12:00:00')).format(
        'YYYY-MM-DD 12:00:00',
      ),
      endDate: moment(dateRange)
        .add(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss'),
      simpleGranularity: null,
      durationGranularity: {
        duration: '86400000',
        origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
      },
    }).converCondit({
      ...productType,
      [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
    });
    const result = getTimestampData(condit,'druid2','/api/routeSr/nonFollowRule/lineChart');
    console.log('获取折线图数据成功');
    return result;
  } catch (error) {
    console.error('获取折线图数据失败:', error);
    return [];
  }
}

function fetchTotalLine(dateRange, productType, access) {
  try {
    console.log('开始获取总计折线图数据');
    const condit = new GenerateCondit({
      dataSource: 'actual_load_unload_waybill_day_result',
      dimensions: [],
      aggregators: [TICKET, CALCWEIGHT],
      startDate: moment(moment(dateRange).format('YYYY-MM-01 00:00:00')).format(
        'YYYY-MM-DD 00:00:00',
      ),
      endDate: moment(dateRange)
        .add(1, 'days')
        .format('YYYY-MM-DD 00:00:00'),
      simpleGranularity: 'day',
    }).converCondit({
      scanType: '分拨装车',
      ...productType,
      [access.isArea ? 'scanProvinceArea' : 'scanSite']: access?.name,
    });
    const result = getTimestampData(condit,'druid2','/api/routeSr/nonFollowRule/lineChart');
    console.log('获取总计折线图数据成功');
    return result;
  } catch (error) {
    console.error('获取总计折线图数据失败:', error);
    return [];
  }
}

function fetchDataPie(dateRange, productType, access) {
  try {
    console.log('开始获取饼图数据');
    const condit = new GenerateCondit({
      dataSource: 'delivery_dis_accord_result',
      dimensions: ['productType'],
      aggregators: [SKETCHTICKET_SIZE(19), CALCWEIGHT],
      startDate: moment(moment(dateRange).format('YYYY-MM-01 12:00:00')).format(
        'YYYY-MM-DD 12:00:00',
      ),
      endDate: moment(dateRange)
        .add(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss'),
      simpleGranularity: 'all',
      durationGranularity: {
        duration: '86400000',
        origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
      },
    }).converCondit({
      ...productType,
      [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
    });
    const result = getData(condit,'druid2');
    console.log('获取饼图数据成功');
    return result;
  } catch (error) {
    console.error('获取饼图数据失败:', error);
    return [];
  }
}

function fetchDataMark(dateRange, productType, access) {
  try {
    console.log('开始获取标记数据');
    const condit = new GenerateCondit({
      dataSource: 'delivery_dis_accord_result',
      dimensions: ['locationMark'],
      aggregators: [SKETCHTICKET_SIZE(19), CALCWEIGHT],
      startDate: moment(moment(dateRange).format('YYYY-MM-01 12:00:00')).format(
        'YYYY-MM-DD 12:00:00',
      ),
      endDate: moment(dateRange)
        .add(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss'),
      simpleGranularity: 'all',
      durationGranularity: {
        duration: '86400000',
        origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
      },
    }).converCondit({
      ...productType,
      [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
    });
    const result = getData(condit,'druid2');
    console.log('获取标记数据成功');
    return result;
  } catch (error) {
    console.error('获取标记数据失败:', error);
    return [];
  }
}
